import { PageHeader } from "@/shared/ui/PageHeader";
import { useTranslation } from "@/shared/providers/LanguageProvider";
import { LandingStatsRow } from "./components/LandingStatsRow";
import { SignupsChart } from "./components/SignupsChart";
import { CTAPerformanceCard } from "./components/CTAPerformanceCard";
import { ABTestResults } from "./components/ABTestResults";

export function LandingDashboard() {
  const { t } = useTranslation();

  return (
    <div className="space-y-5">
      <PageHeader title={t.landing.pageTitle} description={t.landing.pageDescription} />
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3 md:gap-5">
        <LandingStatsRow />
        <SignupsChart />
        <CTAPerformanceCard />
        <ABTestResults />
      </div>
    </div>
  );
}
